import { ReactNode } from "react";
import { TJobSwitchTab } from "../../pages/admin/JobPost/ViewJob";

type Props = {
  tab: TJobSwitchTab;
  setTab: (val: TJobSwitchTab) => void;
  applicant?: number;
  children?: ReactNode;
};

export default function JobSwitchTab({
  tab,
  setTab,
  applicant,
  children,
}: Props) {
  const btn = "text-sm font-medium px-3 py-2 rounded-md";
  const active = "bg-primary text-white";
  const inActive = "bg-white text-body-text";

  return (
    <div className="p-2.5 bg-status-dark-bg rounded-md flex justify-between items-center gap-4 flex-wrap mb-4">
      <div className="flex items-center gap-1.5">
        <button
          className={`${btn} ${tab === "DETAILS" ? active : inActive}`}
          onClick={() => setTab("DETAILS")}
        >
          Details
        </button>
        <button
          className={`${btn} ${tab === "APPLICANT" ? active : inActive}`}
          onClick={() => setTab("APPLICANT")}
        >
          Applicants ({applicant ?? 0})
        </button>
      </div>

      {children && <div>{children}</div>}
    </div>
  );
}
